var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSetupLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 309,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "setup_lines_svg__a",
    cx: 105,
    cy: 33,
    r: 33
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 2)",
    stroke: "#7D32FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4,9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 138c22.713-6.667 34.07-20.333 34.07-41 0-31-28.058-45-31.064-30C0 82 71.146 82 89.183 63c.124 3.217.326 6.362.6 9.434C100.35 190.637 219.197 202.468 209.43 182c-10.02-21-44.09 2-49.1 27-3.341 16.667-6.681 46-10.021 88"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#setup_lines_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 289)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#08A393",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 9,
    y: 5,
    width: 2,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    transform: "rotate(90 10 10)",
    x: 9,
    y: 5,
    width: 2,
    height: 10,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 135)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#08A393",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 9,
    y: 5,
    width: 2,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    transform: "rotate(90 10 10)",
    x: 9,
    y: 5,
    width: 2,
    height: 10,
    rx: 1
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgSetupLines as ReactComponent };